export default __webpack_public_path__ + "static/media/square.ffe0c4f2.svg";